import classNames from 'classnames'

import { ProductGridProps } from './types'
import { useEffect, useRef } from 'react'
import { useProductGridResized } from '../useProductGridResized'

export const ProductGrid = ({
  className,
  gridSize,
  ...props
}: ProductGridProps) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const { publish: publishResized } = useProductGridResized()

  useEffect(() => {
    const unsubscribe = publishResized(ref)
    return () => {
      unsubscribe()
    }
  }, [])

  let gridClasses = ''
  switch (gridSize) {
    case 'lg':
      gridClasses =
        'grid grid-cols-1 sm:grid-cols-2 gap-y-6 sm:gap-y-4 sm:max-w-[80%] md:max-w-[70%] 2xl:max-w-[50%] mx-auto'
      break
    case 'md':
      gridClasses =
        'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-y-6 sm:gap-y-8'
      break
    case 'sm':
      gridClasses = 'grid grid-cols-4 gap-y-[2px] md:grid-cols-6 sm:gap-y-1'
      break
    default:
      gridClasses = ''
      break
  }

  return (
    <div
      ref={ref}
      className={classNames(
        gridClasses,
        'auto-rows-auto	grid-flow-dense auto-rows-[1fr] gap-x-[2px] sm:gap-x-1 mb-8 w-full overflow-hidden',
        className,
      )}
      {...props}
    />
  )
}
